import { TimerType } from '../../System/Timer/TimerTypes';

// TODO: shouldn't this be full TimerType?
type Timers =
    | TimerType.HARVEST
    | TimerType.SEND_GIFT_REQUEST_DATE
    | TimerType.GIFT
    | TimerType.LAST_LOGIN
    | TimerType.LAST_LOGIN_WEEK
    | TimerType.SPIN_WHEEL
    | TimerType.SHOP_GIFT
    | TimerType.FOX_DATE
    | TimerType.SEASON_PASS;

export interface ITimerState {
    timers: Map<Timers, Date>;
}

export const initialTimerState: ITimerState = {
    timers: new Map(),
};
